import { ImageViewer } from "@/components/image-viewer";
import { ImageMetaData, ImageMetaDataDefault } from "@/models/image-meta-data";
import { Button, Modal } from "ant-design-vue";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
	components: {
		Modal,
		ImageViewer,
		Button
	}
})
export default class ImageViewerModal extends Vue {
	@Prop() src?: string;
	@Prop({ default: () => ImageMetaDataDefault }) metadata?: ImageMetaData;

	public visible = false;

	public open() {
		this.visible = true;
	}
	public cancel() {
		this.$emit("cancel");
		this.visible = false;
	}
}
